import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { futureZone, Zone } from '../../interface/zone';
import { Site } from '../../interface/site';
import { Device } from '../../interface/device';

@Injectable()
export class ZoneService {
  zoneAction = new Subject();

  constructor(private httpClient: HttpClient) { }

  list(filter = ""): Observable<Zone[]> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<Zone[]>('zone' + filter);
  }

  count(filter = ""): Observable<any> {
    filter = "?" + filter;
    return this.httpClient.get<any>("zone/count" + filter + "&count=1");
  }

  siteList(): Observable<Site[]> {
    return this.httpClient.get<Site[]>('site');
  }

  scheduledZoneList(id): Observable<futureZone[]> {        
    return this.httpClient.get<futureZone[]>('zone/futureZone/'+ id);
  }

  updateFutureZone(form): Observable<any> {
    let body = form;
    return this.httpClient.patch('zone/futureZone/', body);
  }
  
  deleteFutureZone(id) {
    return this.httpClient.delete('zone/futureZone/' + id);
  }

  create(form): Observable<any> {
    let body = form;
    return this.httpClient.post('zone', body);
  }

  update(form): Observable<any> {
    let body = form;
    return this.httpClient.patch('zone', body);
  }

  delete(id) {
    return this.httpClient.delete('zone/' + id);
  }

  deviceList(deviceName: string, siteId: string, isAutoComplete: number): Observable<Device[]> {
    let filter = "";
    if (isAutoComplete) {
      filter = "?limit=2&where[deviceName]=" + deviceName + "&where[siteId]=" + siteId;
    }
    return this.httpClient.get<Device[]>('device' + filter);
  }

  deleteMapping(zoneId, mapped): Observable<any> {
    let body = mapped;
    return this.httpClient.patch('zone/' + zoneId + '/map', body);
  }

  createMap(zoneId, mapped): Observable<any> {
    let body = mapped;
    return this.httpClient.post('zone/' + zoneId + '/map', body);
  }

  getAction(): Observable<any> {
    return this.zoneAction.asObservable();
  }

  sendAction(action, data) {
    this.zoneAction.next({ action: action, data: data });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/zone/zone.service.ts